import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=727c1967&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=727c1967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c1967",
  null
  
)

export default component.exports